module.exports = __webpack_public_path__ + "img/mining.e80b6054.jpg";